import styles from './style.module.css';
import {ComponentWithChildrenProps} from '@interfaces/component';

export function ProductTabContent({children}: ComponentWithChildrenProps) {
  return <div className={`${styles.productTabContent}`}>{children}</div>;
}
